<ion-app [class.dark]="isDark">
  <!-- Side menu -->
  <ion-menu contentId="main-content" type="overlay" class="side-nav-menu">
    <ion-header class="side-menu-header">
      <ion-toolbar class="side-menu-toolbar">
        <div class="side-menu-brand">
          <img alt="iOPS" src="assets/iops-light-theme-logo.png"
            class="side-menu-logo light-only" />
          <img alt="iOPS" src="assets/iops-dark-theme-logo.png"
            class="side-menu-logo dark-only" />
        </div>
      </ion-toolbar>
    </ion-header>

    <ion-content class="side-menu-content">
      <!-- Getting Started Quick Action -->
      <div class="side-menu-guide-wrap">
        <button
          type="button"
          class="side-menu-guide-pill-btn"
          (click)="openGettingStartedGuide()"
          aria-label="Open Getting Started Guide"
          title="Open Getting Started Guide"
        >
          <ion-icon name="sparkles-outline" aria-hidden="true"></ion-icon>
          <span>Getting Started</span>
        </button>
      </div>

      <ion-list id="inbox-list" class="side-menu-list">
        <!-- Section: Organization (Collapsible Accordion, expanded by default) -->
        <div class="side-menu-section-header">
          <span class="side-menu-section-title">Organization</span>
        </div>

        <ion-accordion-group class="side-menu-accordion-group" [value]="isOrgExpanded ? 'organization' : null" (ionChange)="onOrgAccordionChange($event)">
          <ion-accordion value="organization" class="side-menu-site-accordion side-menu-org-accordion">
            <!-- Organization Accordion Header -->
            @let orgCount = organizationAlarmCount();
            @let orgColor = organizationAlarmColor();

            <ion-item slot="header" lines="none" class="side-site-header-item">
              <div slot="start" class="side-nav-icon-wrap side-nav-icon-wrap--blue">
                <ion-icon name="business-outline" aria-hidden="true"></ion-icon>
              </div>
              <ion-label class="side-site-header-label">
                {{ organizationName || 'Organization' }}
                <span *ngIf="selectedAssetTypeGroupId" class="side-menu-scope-badge" [class.scope-gse]="selectedAssetTypeGroupId === 2" [class.scope-gates]="selectedAssetTypeGroupId === 1">
                  {{ selectedAssetTypeGroupName }}
                </span>
              </ion-label>
              <ion-badge *ngIf="!isOrgExpanded" slot="end" class="side-nav-badge" [color]="orgColor">{{ orgCount }}</ion-badge>
            </ion-item>

            <!-- Organization Sublinks -->
            <div slot="content" class="side-site-sublinks">
              <ion-menu-toggle auto-hide="true">
                <ion-item routerDirection="root" [routerLink]="'/organization-summary/overview'" lines="none" detail="false"
                  routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" class="side-site-subitem">
                  <div slot="start" class="side-site-subicon side-site-subicon--blue">
                    <ion-icon name="albums-outline" aria-hidden="true"></ion-icon>
                  </div>
                  <ion-label>Overview</ion-label>
                </ion-item>
              </ion-menu-toggle>

              <ion-menu-toggle auto-hide="true">
                <ion-item routerDirection="root" [routerLink]="'/organization-summary/tags'" lines="none" detail="false"
                  routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" class="side-site-subitem">
                  <div slot="start" class="side-site-subicon side-site-subicon--cyan">
                    <ion-icon name="pricetags-outline" aria-hidden="true"></ion-icon>
                  </div>
                  <ion-label>Tags</ion-label>
                </ion-item>
              </ion-menu-toggle>

              <ion-menu-toggle auto-hide="true">
                <ion-item routerDirection="root" [routerLink]="'/organization-summary/alarms'" lines="none" detail="false"
                  routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" class="side-site-subitem">
                  <div slot="start" class="side-site-subicon side-site-subicon--amber">
                    <ion-icon name="alert-circle-outline" aria-hidden="true"></ion-icon>
                  </div>
                  <ion-label>Alarms</ion-label>
                  <ion-badge slot="end" class="side-nav-badge" [color]="orgColor">{{ orgCount }}</ion-badge>
                </ion-item>
              </ion-menu-toggle>

              <ion-menu-toggle auto-hide="true">
                <ion-item routerDirection="root" [routerLink]="'/organization-summary/assets-view'" lines="none"
                  detail="false" routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" class="side-site-subitem">
                  <div slot="start" class="side-site-subicon side-site-subicon--indigo">
                    <ion-icon name="list-outline" aria-hidden="true"></ion-icon>
                  </div>
                  <ion-label>{{ assetMenuLabel }}</ion-label>
                  @let orgAssetCount = organizationAssetCount();
                  <ion-badge slot="end" class="side-nav-badge asset-count-badge">{{ orgAssetCount }}</ion-badge>
                </ion-item>
              </ion-menu-toggle>

              @if (organizationHasGSEAssets) {
                <ion-menu-toggle auto-hide="true">
                  <ion-item routerDirection="root" [routerLink]="'/organization-summary/fleet-overview'" lines="none"
                    detail="false" routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" class="side-site-subitem">
                    <div slot="start" class="side-site-subicon side-site-subicon--teal">
                      <ion-icon name="car-outline" aria-hidden="true"></ion-icon>
                    </div>
                    <ion-label>Fleet</ion-label>
                  </ion-item>
                </ion-menu-toggle>

                <ion-menu-toggle auto-hide="true">
                  <ion-item routerDirection="root" [routerLink]="'/organization-summary/map'" lines="none" detail="false"
                    routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" class="side-site-subitem">
                    <div slot="start" class="side-site-subicon side-site-subicon--green">
                      <ion-icon name="map-outline" aria-hidden="true"></ion-icon>
                    </div>
                    <ion-label>Map</ion-label>
                  </ion-item>
                </ion-menu-toggle>
              }

              @if (organizationHasGSAssets) {
                <ion-menu-toggle auto-hide="true">
                  <ion-item routerDirection="root" [routerLink]="organizationGateRoute" lines="none" detail="false"
                    [class.selected]="isOrganizationGateActive" class="side-site-subitem">
                    <div slot="start" class="side-site-subicon side-site-subicon--blue">
                      <ion-icon name="apps-outline" aria-hidden="true"></ion-icon>
                    </div>
                    <ion-label>Gates</ion-label>
                  </ion-item>
                </ion-menu-toggle>
              }

              @if (organizationHasCameraFeeds) {
                <ion-menu-toggle auto-hide="true">
                  <ion-item routerDirection="root" [routerLink]="'/organization-summary/videos'" lines="none" detail="false"
                    routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" class="side-site-subitem">
                    <div slot="start" class="side-site-subicon side-site-subicon--cyan">
                      <ion-icon name="videocam-outline" aria-hidden="true"></ion-icon>
                    </div>
                    <ion-label>Videos</ion-label>
                  </ion-item>
                </ion-menu-toggle>
              }

              <ion-menu-toggle auto-hide="true">
                <ion-item routerDirection="root" [routerLink]="'/organization-summary/more'" lines="none" detail="false"
                  routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" class="side-site-subitem">
                  <div slot="start" class="side-site-subicon side-site-subicon--purple">
                    <ion-icon name="grid-outline" aria-hidden="true"></ion-icon>
                  </div>
                  <ion-label>More</ion-label>
                </ion-item>
              </ion-menu-toggle>
            </div>
          </ion-accordion>
        </ion-accordion-group>

        <!-- Section: Sites (accordion) -->
        @if ((global?.User?.currentUser?.SelectedOrganizationSites?.length || 0) > 1) {
          <div class="side-menu-section-header">
            <span class="side-menu-section-title">Sites</span>
            <span *ngIf="selectedAssetTypeGroupId" class="side-menu-scope-badge" [class.scope-gse]="selectedAssetTypeGroupId === 2" [class.scope-gates]="selectedAssetTypeGroupId === 1">
              {{ selectedAssetTypeGroupName }}
            </span>
            <span class="side-menu-section-count">{{ filteredSites().length }}</span>
          </div>

          <!-- Searchbar on its own line -->
          @if ((global?.User?.currentUser?.SelectedOrganizationSites?.length || 0) > 10) {
            <div class="side-menu-search-wrap">
              <ion-searchbar debounce="150" placeholder="Filter sites…" [(ngModel)]="siteFilter" class="side-menu-searchbar"></ion-searchbar>
            </div>

            <!-- Expand/Collapse controls -->
            <div class="site-controls">
              <ion-button size="small" fill="outline" class="site-ctrl-btn" (click)="expandAll()">Expand all</ion-button>
              <ion-button size="small" fill="clear" class="site-ctrl-btn" (click)="collapseAll()">Collapse all</ion-button>
            </div>
          }

          <ion-accordion-group multiple="true" class="side-menu-accordion-group" [value]="expandedSiteIds"
            (ionChange)="onAccordionChange($event)">
            <ion-accordion *ngFor="let site of filteredSites(); trackBy: trackSite" [value]="site.Id?.toString()" class="side-menu-site-accordion">
              <!-- Accordion header -->
              @let count = getSiteAlarmCountSignal(site.Id)();
              @let color = getSiteAlarmColorSignal(site.Id)();

              <ion-item slot="header" lines="none" class="side-site-header-item">
                <div slot="start" class="side-nav-icon-wrap side-nav-icon-wrap--blue">
                  <ion-icon name="airplane-outline" aria-hidden="true"></ion-icon>
                </div>
                <ion-label class="side-site-header-label">{{ site.Name }}</ion-label>
                <ion-badge *ngIf="!isSiteExpanded(site.Id)" slot="end" class="side-nav-badge" [color]="color">{{ count }}</ion-badge>
              </ion-item>

              <!-- Accordion content -->
              <div slot="content" class="side-site-sublinks">
                <ion-menu-toggle auto-hide="true">
                  <ion-item routerDirection="root" [routerLink]="'site-summary/' + site.Id + '/overview'" lines="none"
                    detail="false" routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" class="side-site-subitem">
                    <div slot="start" class="side-site-subicon side-site-subicon--blue">
                      <ion-icon name="albums-outline" aria-hidden="true"></ion-icon>
                    </div>
                    <ion-label>Overview</ion-label>
                  </ion-item>
                </ion-menu-toggle>

                <ion-menu-toggle auto-hide="true">
                  <ion-item routerDirection="root" [routerLink]="'site-summary/' + site.Id + '/alarms'" lines="none"
                    detail="false" routerLinkActive="selected" class="side-site-subitem">
                    <div slot="start" class="side-site-subicon side-site-subicon--amber">
                      <ion-icon name="alert-circle-outline" aria-hidden="true"></ion-icon>
                    </div>
                    <ion-label>Alarms</ion-label>
                    <ion-badge slot="end" class="side-nav-badge" [color]="color">{{ count }}</ion-badge>
                  </ion-item>
                </ion-menu-toggle>

                <ion-menu-toggle auto-hide="true" *ngIf="site.Cameras.length > 0">
                  <ion-item routerDirection="root" [routerLink]="'site-summary/' + site.Id + '/videos'" lines="none"
                    detail="false" routerLinkActive="selected" class="side-site-subitem">
                    <div slot="start" class="side-site-subicon side-site-subicon--cyan">
                      <ion-icon name="videocam-outline" aria-hidden="true"></ion-icon>
                    </div>
                    <ion-label>Videos</ion-label>
                  </ion-item>
                </ion-menu-toggle>

                <ion-menu-toggle auto-hide="true">
                  <ion-item routerDirection="root" [routerLink]="'site-summary/' + site.Id + '/more'" lines="none"
                    detail="false" routerLinkActive="selected" class="side-site-subitem">
                    <div slot="start" class="side-site-subicon side-site-subicon--purple">
                      <ion-icon name="grid-outline" aria-hidden="true"></ion-icon>
                    </div>
                    <ion-label>More</ion-label>
                  </ion-item>
                </ion-menu-toggle>

                <ion-menu-toggle auto-hide="true">
                  <ion-item routerDirection="root" [routerLink]="'site-summary/' + site.Id + '/assets-view'" lines="none"
                    detail="false" routerLinkActive="selected" class="side-site-subitem">
                    <div slot="start" class="side-site-subicon side-site-subicon--indigo">
                      <ion-icon name="list-outline" aria-hidden="true"></ion-icon>
                    </div>
                    <ion-label>{{ assetMenuLabel }}</ion-label>
                    @let siteAssetCount = getSiteAssetCount(site.Id);
                    <ion-badge slot="end" class="side-nav-badge asset-count-badge">{{ siteAssetCount }}</ion-badge>
                  </ion-item>
                </ion-menu-toggle>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        }

        <!-- Section: Favorites -->
        @let favoriteCount = global?.User?.currentUser?.UserFavoritePaths?.length || 0;
        @if (favoriteCount > 0) {
          <div class="side-menu-section-header side-menu-section-header--with-action">
            <span class="side-menu-section-title">Favorites</span>
            <ion-button fill="clear" size="small" class="side-menu-action-btn" (click)="openEditFavoritesModal()" aria-label="Edit Favorites">
              <ion-icon slot="icon-only" name="pencil-outline"></ion-icon>
            </ion-button>
          </div>

          @if (favoriteCount > 10) {
            <!-- Collapsible Accordion when > 10 items -->
            <ion-accordion-group class="side-menu-accordion-group" [value]="isFavoritesExpanded ? 'favorites' : null" (ionChange)="onFavoritesAccordionChange($event)">
              <ion-accordion value="favorites" class="side-menu-site-accordion side-menu-fav-accordion">
                <!-- Favorites Accordion Header -->
                <ion-item slot="header" lines="none" class="side-site-header-item">
                  <div slot="start" class="side-nav-icon-wrap side-nav-icon-wrap--amber">
                    <ion-icon name="star-outline" aria-hidden="true"></ion-icon>
                  </div>
                  <ion-label class="side-site-header-label">Favorites</ion-label>
                  <ion-badge *ngIf="!isFavoritesExpanded" slot="end" class="side-nav-badge asset-count-badge">{{ favoriteCount }}</ion-badge>
                </ion-item>

                <!-- Favorites Sublinks -->
                <div slot="content" class="side-site-sublinks">
                  <ion-menu-toggle auto-hide="false"
                    *ngFor="let favorite of global.User.currentUser.UserFavoritePaths; let i = index;">
                    <ion-item [routerLink]="getPathWithoutQuery(favorite.Path)" [queryParams]="getQueryParams(favorite.Path)"
                      routerDirection="root" lines="none" detail="false" routerLinkActive="selected"
                      [routerLinkActiveOptions]="{ exact: true }" class="side-site-subitem">
                      <div slot="start" class="side-site-subicon side-site-subicon--amber">
                        <ion-icon name="star-outline" aria-hidden="true"></ion-icon>
                      </div>
                      <ion-label>{{ favorite.Name }}</ion-label>
                    </ion-item>
                  </ion-menu-toggle>
                </div>
              </ion-accordion>
            </ion-accordion-group>
          } @else {
            <!-- Flat list when <= 10 items -->
            <ion-menu-toggle auto-hide="false"
              *ngFor="let favorite of global.User.currentUser.UserFavoritePaths; let i = index;">
              <ion-item [routerLink]="getPathWithoutQuery(favorite.Path)" [queryParams]="getQueryParams(favorite.Path)"
                routerDirection="root" lines="none" detail="false" routerLinkActive="selected"
                [routerLinkActiveOptions]="{ exact: true }" class="side-nav-item">
                <div slot="start" class="side-nav-icon-wrap side-nav-icon-wrap--slate">
                  <ion-icon name="star-outline" aria-hidden="true"></ion-icon>
                </div>
                <ion-label class="side-nav-label">{{ favorite.Name }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
        }

        <!-- Section: Session History -->
        @let historyCount = routeHistory.history().length;
        @if (historyCount > 0) {
          <div class="side-menu-section-header side-menu-section-header--with-action">
            <span class="side-menu-section-title">Session History</span>
            <ion-button fill="clear" size="small" class="side-menu-action-btn" (click)="clearHistory()" aria-label="Clear Session History">
              <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
            </ion-button>
          </div>

          <ion-accordion-group class="side-menu-accordion-group" [value]="isHistoryExpanded ? 'history' : null" (ionChange)="onHistoryAccordionChange($event)">
            <ion-accordion value="history" class="side-menu-site-accordion side-menu-history-accordion">
              <!-- Session History Accordion Header -->
              <ion-item slot="header" lines="none" class="side-site-header-item">
                <div slot="start" class="side-nav-icon-wrap side-nav-icon-wrap--indigo">
                  <ion-icon name="time-outline" aria-hidden="true"></ion-icon>
                </div>
                <ion-label class="side-site-header-label">Session History</ion-label>
                <ion-badge *ngIf="!isHistoryExpanded" slot="end" class="side-nav-badge asset-count-badge">{{ historyCount }}</ion-badge>
              </ion-item>

              <!-- History Sublinks -->
              <div slot="content" class="side-site-sublinks">
                <ion-menu-toggle auto-hide="false"
                  *ngFor="let item of routeHistory.history(); let i = index;">
                  <ion-item [routerLink]="getPathWithoutQuery(item.path)" [queryParams]="getQueryParams(item.path)"
                    routerDirection="root" lines="none" detail="false" routerLinkActive="selected"
                    [routerLinkActiveOptions]="{ exact: true }" class="side-site-subitem">
                    <div slot="start" class="side-site-subicon side-site-subicon--indigo">
                      <ion-icon name="time-outline" aria-hidden="true"></ion-icon>
                    </div>
                    <ion-label>{{ item.title }}</ion-label>
                  </ion-item>
                </ion-menu-toggle>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        }

        <!-- Section: Tools & Settings -->
        <div class="side-menu-section-header">
          <span class="side-menu-section-title">Tools & Settings</span>
        </div>

        <ion-menu-toggle auto-hide="false">
          <ion-item routerDirection="root" [routerLink]="'/settings'" lines="none" detail="false"
            routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }" class="side-nav-item">
            <div slot="start" class="side-nav-icon-wrap side-nav-icon-wrap--slate">
              <ion-icon name="settings-outline" aria-hidden="true"></ion-icon>
            </div>
            <ion-label class="side-nav-label">Settings</ion-label>
          </ion-item>
        </ion-menu-toggle>

        @if (isAdminUser) {
          <ion-menu-toggle auto-hide="false">
            <ion-item routerDirection="root" [routerLink]="'/admin-tools'" lines="none" detail="false"
              routerLinkActive="selected" class="side-nav-item">
              <div slot="start" class="side-nav-icon-wrap side-nav-icon-wrap--purple">
                <ion-icon name="construct-outline" aria-hidden="true"></ion-icon>
              </div>
              <ion-label class="side-nav-label">Admin Tools</ion-label>
              <ion-badge slot="end" class="side-nav-badge side-nav-badge--admin">Admin</ion-badge>
            </ion-item>
          </ion-menu-toggle>
        }

        <!-- Status / Debug info -->
        @if (!userIsBeingProcessed && !userIsBeingAuthenticated && global.User != undefined && (global.User?.isAdmin || global.User?.currentUser?.Organization?.Id == 17)) {
          <div class="side-menu-footer" (click)="showSignalRTest()">
            <span class="signalr-dot" [class.signalr-dot--connected]="hubConnectionState.toLowerCase() === 'connected'"></span>
            <span class="signalr-text">
              signalR: {{ hubConnectionState.toLowerCase() }}, count={{ ((hubConnectionState.toLowerCase() != 'connected' ? '0' : countOfSignalRObservations)).toLocaleString('en') }}
            </span>
          </div>
        }
      </ion-list>
    </ion-content>
  </ion-menu>

  <!-- Router outlet -->
  <ion-router-outlet id="main-content"></ion-router-outlet>
  <lib-in-app-guide></lib-in-app-guide>
</ion-app>
